import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint, EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { convertLegacyPageExtension } from '@backstage/core-compat-api';
import { FluxRuntimePage } from '@backstage-community/plugin-flux';

// This is a custom entity content tab for Flux GitOps
const fluxEntityContent = EntityContentBlueprint.make({
  name: 'flux-gitops-tab',
  params: {
    path: '/flux',
    title: 'GitOps (Flux)',
    filter: 'hasAnnotation("backstage.io/kubernetes-namespace") || hasAnnotation("backstage.io/kubernetes-id")',
    loader: async () =>
      import('./FluxEntityPage.tsx').then(m => <m.FluxEntityPage />),
  },
});

// We can also create a card for the overview page
const fluxKustomizationCard = EntityCardBlueprint.make({
  name: 'flux-kustomizations-card',
  params: {
    filter: 'hasAnnotation("backstage.io/kubernetes-namespace") || hasAnnotation("backstage.io/kubernetes-id")',
    loader: async () =>
      import('@backstage-community/plugin-flux').then(m => <m.EntityFluxKustomizationsCard />),
  },
});

const fluxRuntimePage = convertLegacyPageExtension(FluxRuntimePage, {
  name: 'flux-runtime',
  defaultPath: '/flux-runtime',
});

export const customFluxModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [fluxEntityContent, fluxKustomizationCard],
});

export const customFluxAppModule = createFrontendModule({
  pluginId: 'app',
  extensions: [fluxRuntimePage],
});
